
define('app/board/boardMain',[
	'domReady',
	'app/board/boardApp',
	'app/common/setup'
], function(domReady, BoardApp, Setup){
	domReady(function () {
		Setup.initialize();
		BoardApp.initialize();
    });
});